// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getMessaging, getToken as firebaseGetToken } from "firebase/messaging";

const getToken = firebaseGetToken as any;

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCQNhI4lNoiMWvSd4Covbma0-eOLdbw7B4",
  authDomain: "hygenius-b7c62.firebaseapp.com",
  projectId: "hygenius-b7c62",
  storageBucket: "hygenius-b7c62.firebasestorage.app",
  messagingSenderId: "1086080836183",
  appId: "1:1086080836183:web:154f8f230dfa06668a7912",
  measurementId: "G-TWD3YVN3JN",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const messaging = getMessaging(app);

export const requestToken = async () => {
  try {
    if (!import.meta.env.VITE_APP_FIREBASE_KEY) {
      console.error("FCM Flow: VITE_APP_FIREBASE_KEY is missing in .env!");
      return;
    }

    const permission = await Notification.requestPermission();
    // console?.log("permission", permission);
    if (permission !== "granted") {
      console.warn(
        "FCM Flow: Notification permission not granted. Permission status:",
        permission,
      );
      return;
    }

    const registration = await navigator.serviceWorker.ready;
    console?.log("registration", registration);
    if (!registration) {
      console.error("FCM Flow: Service worker registration not found.");
      return;
    }

    const token = await getToken(messaging, {
      vapidKey: import.meta.env.VITE_APP_FIREBASE_KEY,
      serviceWorkerRegistration: registration,
    });

    if (token) {
      localStorage.setItem("fcmToken", token);
    } else {
      console.warn(
        "FCM Flow: getToken returned null. No registration token available.",
      );
    }
  } catch (error) {
    console.error("FCM Flow: Exception occurred while getting token:", error);
  }
};

export { app, analytics, messaging };
